module.exports = __webpack_public_path__ + "02186d90d56a4875d525dd4f3e01ae93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/img/undo-icon-sw.png
// module id = 27
// module chunks = 0